import { render, staticRenderFns } from "./PorletMenuSearch.vue?vue&type=template&id=5e925754&"
import script from "./PorletMenuSearch.vue?vue&type=script&lang=js&"
export * from "./PorletMenuSearch.vue?vue&type=script&lang=js&"
import style0 from "./PorletMenuSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports